import { QrcodeSuccessCallback } from 'html5-qrcode/esm/core';
import { useModalState } from '../../../../../hooks/useModalState';

interface UseSearchBarBarcodeScanParams {
  onDecode: (decodedText: string) => void;
}

const useSearchBarBarcodeScan = ({ onDecode }: UseSearchBarBarcodeScanParams) => {
  const { isOpen, openModal, closeModal } = useModalState();

  const onScanSuccess: QrcodeSuccessCallback = (decodedText) => {
    closeModal();
    onDecode(decodedText);
  };

  return { isOpen, openModal, closeModal, onScanSuccess };
};

export default useSearchBarBarcodeScan;
